export default "__VITE_ASSET__b1699b98__"